import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
  ListGroup,
  ListGroupItem, // Eğer PollOptionsManager içinde kullanılıyorsa buraya gerek yok
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Date, NameSurname, Status } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getSliders as onGetPolls,
  addSlider as onAddPoll, // Bu dispatch çağrısı sadece ana anketin eklenmesi içindir
  updateSlider as onUpdatePoll,
  deleteSlider as onDeletePoll,
} from "store/contacts/actions"; // Bu aksiyonların backend ile uyumlu olduğundan emin olun

import { useSelector, useDispatch } from "react-redux";

import moment from "moment";

// Flatpickr importları
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import PollOptionsManager from "./PollOptionsManager"; // PollOptionsManager'ı import ettik

const ContactsList = props => {
  const tableRef = useRef(null);

  document.title = "Anketler | Oyliyo ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState(); // Silinecek anket bilgisini tutar
  const [contactEdit, setEditContact] = useState(null); // Düzenlenen anketin tüm detaylarını tutar

  // Anket Ana Görseli
  const [getFileName, setFileName] = useState(null);

  // Anket Durumu ve Yayınlama
  const [pollStatus, setPollStatus] = useState("Taslak"); // Taslak, Yayında, Planlandı
  const [publishDateTime, setPublishDateTime] = useState(null); // Planlama tarihi ve saati

  // Anket Tipi (Normal / Sponsorlu)
  const [pollType, setPollType] = useState("Normal");
  const [sponsorLogo, setSponsorLogo] = useState('');
  const [sponsorCompanyName, setSponsorCompanyName] = useState('');

  // Anket Süresi
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDurationless, setIsDurationless] = useState(false); // Süresiz checkbox

  // Hedef Kitle (Opsiyonel)
  const [getPollGender, setPollGender] = useState("");
  const [getPollAge, setPollAge] = useState("");
  const [getPollCity, setPollCity] = useState("");

  // Ek Özellikler
  const [isLikesActive, setIsLikesActive] = useState(false);
  const [isCommentsActive, setIsCommentsActive] = useState(false);
  const [isSuggestionsActive, setIsSuggestionsActive] = useState(false);

  // Modallar
  const [modal, setModal] = useState(false); // Ana anket ekleme/düzenleme modalı
  const [deleteModal, setDeleteModal] = useState(false);
  // Anket seçenekleri için ayrı bir modal kullanmıyoruz artık, ana modal içine entegre ettik.
  // const [pollOptionsModal, setPollOptionsModal] = useState(false); 
  const [currentPoll, setCurrentPoll] = useState(null); // Seçenek modalında veya düzenlemede kullanılacak anket objesi

  // Yeni Anket Ekleme sırasında, PollOptionsManager'dan gelen geçici seçenekleri tutan state
  const [newPollOptions, setNewPollOptions] = useState([]);

  // Dropdown verileri
  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);
  const [getUsersID, setUsersID] = useState(null);
  const [getUsers, setUsers] = useState([]);
  const [getCities, setCities] = useState([]);

  // isEdit, anketin düzenlenip düzenlenmediğini belirtir
  const [isEdit, setIsEdit] = useState(false);

  // Formik Doğrulama Şeması
  const validation = useFormik({
    enableReinitialize: true, // initialValues'ın değiştiğinde formu yeniden başlatmasını sağlar
    initialValues: {
      Poll_Title: (contactEdit && contactEdit.Poll_Title) || "",
      Poll_Description: (contactEdit && contactEdit.Poll_ShortDesc) || "",
      Users_ID: (contactEdit && contactEdit.Users_ID) || "",
      Poll_Category_ID: (contactEdit && contactEdit.Poll_Category_ID) || "",
      Poll_StartDate: (contactEdit && contactEdit.Poll_StartDate ? moment(contactEdit.Poll_StartDate).toDate() : null) ,
      Poll_EndDate: (contactEdit && contactEdit.Poll_EndDate ? moment(contactEdit.Poll_EndDate).toDate() : null) ,
      IsDurationless: (contactEdit && contactEdit.IsDurationless) || false,
      Poll_Type: (contactEdit && contactEdit.Poll_Type) || "Normal",
      Sponsor_Logo: (contactEdit && contactEdit.Sponsor_Logo) || "",
      Sponsor_CompanyName: (contactEdit && contactEdit.Sponsor_CompanyName) || "",
      Poll_Status: (contactEdit && contactEdit.Poll_Status) || "Taslak",
      Publish_DateTime: (contactEdit && contactEdit.Publish_DateTime ? moment(contactEdit.Publish_DateTime).toDate() : null) ,
      Poll_Gender: (contactEdit && contactEdit.Poll_Gender) || "",
      Poll_Age: (contactEdit && contactEdit.Poll_Age) || "",
      Poll_City: (contactEdit && contactEdit.Poll_City) || "",
      IsLikesActive: (contactEdit && contactEdit.IsLikesActive) || false,
      IsCommentsActive: (contactEdit && contactEdit.IsCommentsActive) || false,
      IsSuggestionsActive: (contactEdit && contactEdit.IsSuggestionsActive) || false,
    },
    validationSchema: Yup.object({
      Poll_Title: Yup.string()
        .required("Başlık alanı boş bırakılamaz.")
        .max(150, "Başlık en fazla 150 karakter olabilir."),
      Poll_Description: Yup.string().nullable(),
      Users_ID: Yup.number().required("Kullanıcı seçimi zorunludur.").nullable(),
      Poll_Category_ID: Yup.number().required("Kategori seçimi zorunludur.").nullable(),
      IsDurationless: Yup.boolean(),
      Poll_StartDate: Yup.date().nullable().when('IsDurationless', {
        is: false,
        then: (schema) => schema.required("Başlangıç tarihi zorunludur.").typeError("Geçerli bir tarih giriniz."),
      }),
      Poll_EndDate: Yup.date().nullable().when('IsDurationless', {
        is: false,
        then: (schema) => schema.required("Bitiş tarihi zorunludur.")
          .typeError("Geçerli bir tarih giriniz.")
          .min(
            Yup.ref('Poll_StartDate'),
            "Bitiş tarihi başlangıç tarihinden sonra olmalıdır."
          ),
      }),
      Poll_Type: Yup.string().required("Anket tipi seçimi zorunludur."),
      Sponsor_CompanyName: Yup.string().nullable().when('Poll_Type', {
        is: 'Sponsorlu',
        then: (schema) => schema.required("Sponsor firma adı zorunludur."),
      }),
      Sponsor_Logo: Yup.string().nullable().when('Poll_Type', {
        is: 'Sponsorlu',
        then: (schema) => schema.required("Sponsor logo yüklenmesi zorunludur."),
      }),
      Poll_Status: Yup.string().required("Durum seçimi zorunludur."),
      Publish_DateTime: Yup.date().nullable().when('Poll_Status', {
        is: 'Planlandı',
        then: (schema) => schema.required("Yayınlanma tarihi ve saati zorunludur.").typeError("Geçerli bir tarih ve saat giriniz."),
      }),
      Poll_Gender: Yup.string().nullable(),
      Poll_Age: Yup.string().nullable(),
      Poll_City: Yup.string().nullable(),
      IsLikesActive: Yup.boolean(),
      IsCommentsActive: Yup.boolean(),
      IsSuggestionsActive: Yup.boolean(),
    }),
    onSubmit: async (values) => { // Async olarak tanımlandı
      const isActiveValue = values.Poll_Status === "Yayında";
      const localDate = moment().local();

      const basePollData = {
        Poll_Title: values.Poll_Title,
        Poll_ShortDesc: values.Poll_Description,
        Users_ID: parseInt(values.Users_ID),
        Poll_Category_ID: parseInt(values.Poll_Category_ID),
        Poll_Url: getFileName,
        Poll_Url_MobileCheck: false, // Bu alanı backend'e göre ayarlamalısın

        Poll_StartDate: values.IsDurationless ? null : (values.Poll_StartDate ? moment(values.Poll_StartDate).format("YYYY-MM-DD") : null),
        Poll_EndDate: values.IsDurationless ? null : (values.Poll_EndDate ? moment(values.Poll_EndDate).format("YYYY-MM-DD") : null),
        IsDurationless: values.IsDurationless,

        Poll_Type: values.Poll_Type,
        Sponsor_Logo: values.Poll_Type === "Sponsorlu" ? sponsorLogo : null,
        Sponsor_CompanyName: values.Poll_Type === "Sponsorlu" ? values.Sponsor_CompanyName : null,

        Poll_Gender: values.Poll_Gender || "",
        Poll_Age: values.Poll_Age || "",
        Poll_City: values.Poll_City || "",

        IsActive: isActiveValue,
        Poll_Status: values.Poll_Status,
      //  Publish_DateTime: values.Poll_Status === "Planlandı" && values.Publish_DateTime ? moment(values.Publish_DateTime).format("YYYY-MM-DD HH:mm:ss") : null,

        IsLikesActive: values.IsLikesActive,
        IsCommentsActive: values.IsCommentsActive,
        IsSuggestionsActive: values.IsSuggestionsActive,
      };

      if (isEdit) {
        const updatedPoll = {
          ID: contactEdit.ID,
          ...basePollData,
          // Düzenleme modunda seçenekler PollOptionsManager tarafından zaten API üzerinden yönetiliyor.
          // Bu nedenle, buraya seçenekleri eklemeye gerek yok.
        };
        // Redux aksiyonunu dispatch et
        dispatch(onUpdatePoll(updatedPoll));
        setIsEdit(false);
      } else {
        // Yeni anket ekleme
        try {
                    console.log("YbasePollData", basePollData);

          // 1. Önce ana anket verilerini kaydet
          const addPollResponse = await axios.post('https://adminoy.oyliyo.com.tr:9654/addPoll/send', {
            ...basePollData,
            Created_DateTime: localDate, // Oluşturulma tarihi
          });

          console.log("Yeni Anket Eklendi:", addPollResponse.data);
          // Backend'den dönen yeni anketin ID'sini al
          const newPollId = addPollResponse.data.value[0].ID; 

          // 2. Eğer yeni eklenen seçenekler varsa, onları da kaydet
          if (newPollOptions.length > 0) {
            for (const option of newPollOptions) {
              const newOptionPayload = {
                Poll_Option_Title: option.Poll_Option_Title,
                Poll_ID: newPollId, // Yeni anket ID'si ile ilişkilendir
              };
              await axios.post('https://adminoy.oyliyo.com.tr:9654/addPollOptions/send', newOptionPayload);
              console.log(`Seçenek "${option.Poll_Option_Title}" yeni ankete eklendi.`);
            }
          }


      //  const pollUsersResponse = await axios.get('https://adminoy.oyliyo.com.tr:9654/getPollUsers/select/');
  //const pollUsers = pollUsersResponse.data; // Burada array bekliyoruz


   await axios.post('https://adminoy.oyliyo.com.tr:9654/postPush/send', {
    title: "Yeni Anket Yayında!",
    body: `${values.Poll_Title} başlıklı yeni bir anket eklendi.`,
    sound: "default",
    icerikTuru: "poll"
  });
  console.log("Tüm kullanıcılara bildirim isteği gönderildi.");


  {/**  for (const user of pollUsers) {
    if (!user.ID) continue; // ID yoksa atla

    console.log("şmsdşf",user)
    await axios.post('https://adminoy.oyliyo.com.tr:9654/postPush/send', {
      USERID: user.ID,
      title: "Yeni Anket Yayında!",
      body: `${basePollData.Poll_Title} başlıklı yeni bir anket eklendi.`,
      sound: "default",
      icerikTuru: "poll"
    });
  }
*/}
  // 3.2 Her kullanıcıya push gönder
 
          // Redux'u güncelle (yeni eklenen anketi ve muhtemelen seçeneklerini içeren)
          dispatch(onGetPolls()); 
        } catch (error) {
          console.error("Yeni anket veya seçenekler eklenirken hata oluştu:", error);
          // Kullanıcıya hata mesajı gösterebilirsiniz.
        }
      }
      validation.resetForm(); // Formik formunu sıfırla
      resetFormStates(); // Tüm yerel state'leri sıfırla
      toggle(); // Modalı kapat
    },
  });

  const { polls } = useSelector(state => ({
    polls: state.contacts.sliders, // Redux store'daki 'sliders'ı 'polls' olarak kabul ettim
  }));

  // Anketleri başlangıçta veya Redux state'i değiştiğinde getir
  useEffect(() => {
    if (polls && !polls.length) {
      dispatch(onGetPolls());
    }
  }, [dispatch, polls]);

  // Redux'tan gelen anketler değiştiğinde yerel state'i güncelle
  useEffect(() => {
    setContact(polls);
  }, [polls]);

  // Form state'lerini başlangıç değerlerine sıfırlayan fonksiyon
  const resetFormStates = () => {
    validation.resetForm(); // Formik form değerlerini sıfırla
    setEditContact(null); // Düzenlenen anketi temizle

    setFileName(null); // Görsel dosya adını temizle

    setPollStatus("Taslak");
    setPublishDateTime(null);

    setPollType("Normal");
    setSponsorLogo('');
    setSponsorCompanyName('');

    setStartDate(null);
    setEndDate(null);
    setIsDurationless(false);

    setPollGender("");
    setPollAge("");
    setPollCity("");

    setIsLikesActive(false);
    setIsCommentsActive(false);
    setIsSuggestionsActive(false);

    setCategoryID(null);
    setUsersID(null);
    setNewPollOptions([]); // **ÖNEMLİ:** Yeni anket seçeneklerini de temizle
  };

  // Ana modalı açıp kapatan fonksiyon
  const toggle = () => {
    if (modal) { // Modal kapanıyorsa
      resetFormStates(); // State'leri sıfırla
    }
    setModal(!modal);
  };

  // Mevcut anketi düzenlemek için tıklama işleyici
  const handleUserClick = (arg) => {
    const poll = arg;
    setEditContact(poll); // Düzenlenecek anketi set et

    setFileName(poll.Poll_Url || null); // Mevcut görseli set et

    setPollStatus(poll.Poll_Status || "Taslak");
    setPublishDateTime(poll.Publish_DateTime ? moment(poll.Publish_DateTime).toDate() : null); // Tarih objesine dönüştür

    setPollType(poll.Poll_Type || "Normal");
    setSponsorLogo(poll.Sponsor_Logo || '');
    setSponsorCompanyName(poll.Sponsor_CompanyName || '');

    setStartDate(poll.Poll_StartDate ? moment(poll.Poll_StartDate).toDate() : null); // Tarih objesine dönüştür
    setEndDate(poll.Poll_EndDate ? moment(poll.Poll_EndDate).toDate() : null); // Tarih objesine dönüştür
    setIsDurationless(poll.IsDurationless || false);

    setPollGender(poll.Poll_Gender || "");
    setPollAge(poll.Poll_Age || "");
    setPollCity(poll.Poll_City || "");

    setIsLikesActive(poll.IsLikesActive || false);
    setIsCommentsActive(poll.IsCommentsActive || false);
    setIsSuggestionsActive(poll.IsSuggestionsActive || false);

    setCategoryID(poll.Poll_Category_ID);
    setUsersID(poll.Users_ID);

    setCurrentPoll(poll); // PollOptionsManager için currentPoll'u set et
    setNewPollOptions([]); // Düzenleme moduna geçerken geçici seçenekleri temizle

    setIsEdit(true); // Düzenleme modunda olduğunu belirt
    setModal(true); // Modalı aç
  };

  // Yeni anket eklemek için tıklama işleyici
  const handleUserClicks = () => {
    setIsEdit(false); // Yeni ekleme modunda olduğunu belirt
    resetFormStates(); // Tüm formu ve seçenekleri sıfırla
    setModal(true); // Modalı aç
  };

  // PollOptionsManager'dan gelen güncellenmiş yeni anket seçeneklerini yakalamak için callback
  const handleNewPollOptionsChange = useCallback((options) => {
    setNewPollOptions(options);
  }, []); // Bağımlılık dizisi boş bırakılabilir veya setPollOptions'ın kendisi eklenebilir

  // Dropdown seçimlerini güncelleme fonksiyonları
  const _setChoiceUser = arg => {
    setUsersID(arg.target.value);
    validation.setFieldValue("Users_ID", arg.target.value);
  }

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
    validation.setFieldValue("Poll_Category_ID", arg.target.value);
  }

  const _setChoiceGender = arg => {
    setPollGender(arg.target.value);
    validation.setFieldValue("Poll_Gender", arg.target.value);
  }

  const _setChoiceAge = arg => {
    setPollAge(arg.target.value);
    validation.setFieldValue("Poll_Age", arg.target.value);
  }

  const _setChoiceCity = arg => {
    setPollCity(arg.target.value);
    validation.setFieldValue("Poll_City", arg.target.value);
  }

  // Dropzone önizleme bileşeni
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} alt="Preview" /> <span className="name">{name}</span> - <span className="status">{status === "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    );
  };

  // Dosya yükleme parametrelerini döndüren fonksiyon
  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };

  // Anket ana görseli yükleme durumu değiştiğinde çağrılır
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          try {
            const result = JSON.parse(xhr.response);
            if (result && result.file && result.file.filename) {
              setFileName(result.file.filename);
              // Güncel filename'ı Formik değerlerine de yansıtın
              validation.setFieldValue("Poll_Url", result.file.filename);
            } else {
              console.error("Yükleme başarılı ancak dosya adı bulunamadı:", result);
            }
          } catch (error) {
            console.error("JSON ayrıştırma hatası:", error);
          }
        }
      };
    }
  };

  // Sponsor logo yükleme durumu değiştiğinde çağrılır
  const handleSponsorLogoUploadStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          try {
            const result = JSON.parse(xhr.response);
            if (result && result.file && result.file.filename) {
              setSponsorLogo(result.file.filename);
              // Güncel sponsor logo filename'ı Formik değerlerine de yansıtın
              validation.setFieldValue("Sponsor_Logo", result.file.filename);
            } else {
              console.error("Sponsor logo yükleme başarılı ancak dosya adı bulunamadı:", result);
            }
          } catch (error) {
            console.error("Sponsor logo JSON ayrıştırma hatası:", error);
          }
        }
      };
    }
  };

  // Anket seçenekleri modalını açmak için (eskiden kullanılıyordu, artık ana modal içinde)
  // const handleManagePollOptions = (pollData) => {
  //   setCurrentPoll(pollData);
  //   setPollOptionsModal(true);
  // };

  // const togglePollOptionsModal = () => {
  //   setPollOptionsModal(!pollOptionsModal);
  //   if (pollOptionsModal) {
  //     setCurrentPoll(null);
  //   }
  // };

  // Anket listesini Redux üzerinden yenilemek için
  const refreshPolls = useCallback(() => {
    dispatch(onGetPolls());
  }, [dispatch]);

  // Silme işlemi için tıklama işleyici
  const onClickDelete = poll => {
    setContact(poll);
    setDeleteModal(true);
  };

  // Silme işlemini onaylama
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeletePoll(contact.ID));
    }
    setDeleteModal(false);
  };

  // React Table sütun tanımları
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Foto",
        accessor: "Poll_Url",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return (
            <div>
              {cellProps.value ? (
                <img
                  className="rounded-circle avatar-md"
                  src={cellProps.row.original.Poll_Url_MobileCheck === true ? 'https://kontimderadmin.stechomeyazilim.com/Uploads/' + cellProps.value : 'https://megasubdomain.stechomeyazilim.info/' + cellProps.value}
                  alt=""
                />
              ) : (
                <div className="avatar-xs">
                  {cellProps.row.original.Poll_Title ? (
                    <span className="avatar-title rounded-circle bg-light text-primary">
                      {cellProps.row.original.Poll_Title.charAt(0)}
                    </span>
                  ) : null}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Başlık",
        accessor: "Poll_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Açıklama",
        accessor: "Poll_ShortDesc",
        filterable: true,
        Cell: cellProps => {
          return <span className="text-muted">{cellProps.value ? (cellProps.value.length > 50 ? cellProps.value.substring(0, 50) + "..." : cellProps.value) : "Yok"}</span>;
        },
      },
      {
        Header: "Kategori",
        accessor: "Poll_Category.Poll_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Kullanıcı",
        accessor: "Users.Users_NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Anket Tipi",
        accessor: "Poll_Type",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value === "Sponsorlu" ? <span className="badge bg-primary">Sponsorlu</span> : <span className="badge bg-secondary">Normal</span>;
        },
      },
      {
        Header: "Başlangıç",
        accessor: "Poll_StartDate",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? moment(cellProps.value).format("DD-MM-YYYY") : "Süresiz";
        },
      },
      {
        Header: "Bitiş",
        accessor: "Poll_EndDate",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? moment(cellProps.value).format("DD-MM-YYYY") : "Süresiz";
        },
      },
      {
        Header: "Durum",
        accessor: "Poll_Status",
        filterable: true,
        Cell: cellProps => {
          let badgeClass = "";
          let statusText = "";

          // Backend'den gelen IsActive (boolean) ve Poll_Status (string) değerlerini dikkate al
          // Poll_Status'u string olarak doğrudan alıyorsa bu şekilde
          switch (cellProps.row.original.Poll_Status) { // 'Poll_Status' alanını direkt kullan
            case "Yayında":
              badgeClass = "bg-success";
              statusText = "Yayında";
              break;
            case "Taslak":
              badgeClass = "bg-warning";
              statusText = "Taslak";
              break;
            case "Planlandı":
              badgeClass = "bg-info";
              statusText = `Planlandı (${moment(cellProps.row.original.Publish_DateTime).format("DD.MM.YYYY HH:mm")})`;
              break;
            default:
              // Eğer IsActive değeri de varsa, onu da kontrol edebiliriz
              if (cellProps.row.original.IsActive === true) {
                 badgeClass = "bg-success";
                 statusText = "Yayında (API)";
              } else if (cellProps.row.original.IsActive === false) {
                 badgeClass = "bg-warning";
                 statusText = "Taslak (API)";
              } else {
                 badgeClass = "bg-secondary";
                 statusText = "Bilinmiyor";
              }
              break;
          }
          return <span className={`badge ${badgeClass}`}>{statusText}</span>;
        },
      },
      {
        Header: "Cinsiyet",
        accessor: "Poll_Gender",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value === "M" ? "Erkek" : cellProps.value === "F" ? "Kadın" : "Tümü";
        },
      },
      {
        Header: "Yaş",
        accessor: "Poll_Age",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value || "Tümü";
        },
      },
      {
        Header: "Şehir",
        accessor: "Poll_City",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value || "Tümü";
        },
      },
      {
        Header: "Oluşturulma Tarihi",
        accessor: "Created_DateTime",
        filterable: true,
        Cell: cellProps => {
          return moment(cellProps.value).format("DD-MM-YYYY HH:mm");
        },
      },
   
      {
        Header: "Soru Önerisi",
        accessor: "IsSuggestionsActive",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? <i className="mdi mdi-check-circle text-success font-size-18"></i> : <i className="mdi mdi-close-circle text-danger font-size-18"></i>;
        },
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              {/* Seçenekleri Yönet düğmesi (sadece mevcut anketler için) */}
              <Link
                to="#"
                className="text-primary"
                onClick={() => {
                  const pollData = cellProps.row.original;
                  // Seçenekleri yönetmek için ana modalı aç ve düzenleme moduna geç
                  handleUserClick(pollData); 
                  // Eğer ayrı bir seçenek modalı olsaydı: handleManagePollOptions(pollData);
                }}
              >
                <i className="mdi mdi-format-list-bulleted font-size-18" id="optionsviewtooltip" />
                <UncontrolledTooltip placement="top" target="optionsviewtooltip">
                  Seçenekleri Yönet
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData); // Düzenleme modunda modalı açar
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  // Kategori, kullanıcı ve şehir verilerini çeken useEffect
  useEffect(() => {
    const fetchRelatedData = async () => {
      try {
        const categoriesRes = await axios.get('https://adminoy.oyliyo.com.tr:9654/getPollCategory/select');
        setCategory(categoriesRes.data);

        const usersRes = await axios.get('https://adminoy.oyliyo.com.tr:9654/getPollUsers/select');
        setUsers(usersRes.data);

        const citiesRes = await axios.get('https://adminoy.oyliyo.com.tr:9654/getCity/TR');
        setCities(citiesRes.data);

      } catch (error) {
        console.error("İlgili veriler çekilirken hata oluştu:", error);
      }
    };

    fetchRelatedData();
  }, []); // Sadece bir kez çalışması için boş bağımlılık dizisi

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      {/* Anket seçenekleri için ayrı bir modal kullanmıyoruz artık. 
          PollOptionsManager'ı ana anket modalının içine taşıdık.
          Bu yüzden bu modal kısmını yorum satırı yaptım. */}
      {/* <Modal isOpen={pollOptionsModal} toggle={togglePollOptionsModal} size="lg">
        <ModalHeader toggle={togglePollOptionsModal} tag="h4">
          {currentPoll ? `"${currentPoll.Poll_Title}" Anket Seçenekleri` : "Anket Seçenekleri"}
        </ModalHeader>
        {currentPoll && (
          <PollOptionsManager
            pollId={currentPoll.ID}
            initialOptions={currentPoll.Poll_Options || []}
            onOptionActionSuccess={refreshPolls}
          />
        )}
      </Modal> */}

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Anket Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={polls}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddPoll={true} // "Yeni Anket Ekle" butonu için
                    handleOrderClicks={handleUserClicks} // Bu butona basıldığında yeni anket ekleme moduna geçilecek
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Anketi Düzenle" : "Yeni Anket Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault(); // Varsayılan form gönderimini engelle
                          validation.handleSubmit(); // Formik'in gönderim işleyicisini çağır
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollTitle">Anket Başlığı</Label>
                              <Input
                                id="pollTitle"
                                name="Poll_Title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                maxLength="150"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_Title || ""}
                                invalid={
                                  validation.touched.Poll_Title &&
                                    validation.errors.Poll_Title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.Poll_Title &&
                                validation.errors.Poll_Title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.Poll_Title}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollDescription">Anket Açıklaması (Opsiyonel)</Label>
                              <Input
                                id="pollDescription"
                                name="Poll_Description"
                                type="textarea"
                                rows="3"
                                placeholder="Anket hakkında kısa bir açıklama giriniz..."
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_Description || ""}
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="usersId">Kullanıcı Seçiniz</Label>
                              <Input
                                id="usersId"
                                name="Users_ID"
                                type="select"
                                className="form-select"
                                onChange={(text) => _setChoiceUser(text)}
                                onBlur={validation.handleBlur}
                                value={validation.values.Users_ID || ""}
                                invalid={
                                  validation.touched.Users_ID &&
                                    validation.errors.Users_ID
                                    ? true
                                    : false
                                }
                              >
                                <option value="">Lütfen Kullanıcı Seçiniz</option>
                                {getUsers.map((item) => (
                                  <option value={item.ID} key={item.ID}>{item.Users_NameSurname}</option>
                                ))}
                              </Input>
                              {validation.touched.Users_ID &&
                                validation.errors.Users_ID ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.Users_ID}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollCategoryId">Kategori Seçiniz</Label>
                              <Input
                                id="pollCategoryId"
                                name="Poll_Category_ID"
                                type="select"
                                className="form-select"
                                onChange={(text) => _setChoiceCategory(text)}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_Category_ID || ""}
                                invalid={
                                  validation.touched.Poll_Category_ID &&
                                    validation.errors.Poll_Category_ID
                                    ? true
                                    : false
                                }
                              >
                                <option value="">Lütfen Kategori Seçiniz</option>
                                {getCategory.map((item) => (
                                  <option value={item.ID} key={item.ID}>{item.Poll_Category_Title}</option>
                                ))}
                              </Input>
                              {validation.touched.Poll_Category_ID &&
                                validation.errors.Poll_Category_ID ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.Poll_Category_ID}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <h5 className="font-size-14 mb-3 mt-4">Anket Süresi</h5>
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="startDate">Başlangıç Tarihi</Label>
                              <Flatpickr
                                id="startDate"
                                className="form-control d-block"
                                placeholder="Başlangıç Tarihi Seçiniz"
                                value={startDate} // state tarafından yönetiliyor
                                onChange={([date]) => {
                                  setStartDate(date);
                                  validation.setFieldValue("Poll_StartDate", date);
                                }}
                                options={{
                                  altInput: true,
                                  altFormat: "d F Y",
                                  dateFormat: "Y-m-d",
                                  minDate: "today",
                                }}
                                disabled={isDurationless}
                              />
                              {validation.touched.Poll_StartDate && validation.errors.Poll_StartDate ? (
                                <FormFeedback type="invalid" className="d-block">
                                  {validation.errors.Poll_StartDate}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="endDate">Bitiş Tarihi</Label>
                              <Flatpickr
                                id="endDate"
                                className="form-control d-block"
                                placeholder="Bitiş Tarihi Seçiniz"
                                value={endDate} // state tarafından yönetiliyor
                                onChange={([date]) => {
                                  setEndDate(date);
                                  validation.setFieldValue("Poll_EndDate", date);
                                }}
                                options={{
                                  altInput: true,
                                  altFormat: "d F Y",
                                  dateFormat: "Y-m-d",
                                  minDate: startDate || "today",
                                }}
                                disabled={isDurationless}
                              />
                              {validation.touched.Poll_EndDate && validation.errors.Poll_EndDate ? (
                                <FormFeedback type="invalid" className="d-block">
                                  {validation.errors.Poll_EndDate}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3 form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="isDurationlessCheck"
                                defaultChecked={isDurationless} // checked prop'u state tarafından yönetilmeli
                                onChange={(e) => {
                                  setIsDurationless(e.target.checked);
                                  validation.setFieldValue("IsDurationless", e.target.checked);
                                  if (e.target.checked) {
                                    setStartDate(null);
                                    setEndDate(null);
                                    validation.setFieldValue("Poll_StartDate", null);
                                    validation.setFieldValue("Poll_EndDate", null);
                                  } else {
                                    // Eğer süresiz kaldırılırsa, varsayılan olarak bugün ve 7 gün sonrasını ayarla
                                    const now = moment().toDate();
                                    const defaultEndDate = moment().add(7, 'days').toDate();
                                    setStartDate(now);
                                    setEndDate(defaultEndDate);
                                    validation.setFieldValue("Poll_StartDate", now);
                                    validation.setFieldValue("Poll_EndDate", defaultEndDate);
                                  }
                                }}
                              />
                              <Label className="form-check-label" htmlFor="isDurationlessCheck">
                                Süresiz Yap
                              </Label>
                            </div>

                            <h5 className="font-size-14 mb-3 mt-4">Anket Tipi</h5>
                            <div className="mb-3">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pollTypeOptions"
                                  id="normalPoll"
                                  value="Normal"
                                  checked={pollType === "Normal"} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setPollType(e.target.value);
                                    validation.setFieldValue("Poll_Type", e.target.value);
                                    // Normal anket seçildiğinde sponsor bilgilerini temizle
                                    validation.setFieldValue("Sponsor_Logo", null);
                                    validation.setFieldValue("Sponsor_CompanyName", "");
                                    setSponsorLogo('');
                                    setSponsorCompanyName('');
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="normalPoll">
                                  Normal Anket
                                </Label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pollTypeOptions"
                                  id="sponsoredPoll"
                                  value="Sponsorlu"
                                  checked={pollType === "Sponsorlu"} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setPollType(e.target.value);
                                    validation.setFieldValue("Poll_Type", e.target.value);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="sponsoredPoll">
                                  Sponsorlu Anket
                                </Label>
                              </div>
                            </div>

                            {pollType === "Sponsorlu" && (
                              <>
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="sponsorCompanyName">Sponsor Firma Adı</Label>
                                  <Input
                                    id="sponsorCompanyName"
                                    name="Sponsor_CompanyName"
                                    type="text"
                                    placeholder="Sponsor Firma Adını Giriniz"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Sponsor_CompanyName || ""}
                                    invalid={
                                      validation.touched.Sponsor_CompanyName &&
                                        validation.errors.Sponsor_CompanyName
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.Sponsor_CompanyName &&
                                    validation.errors.Sponsor_CompanyName ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.Sponsor_CompanyName}
                                    </FormFeedback>
                                  ) : null}
                                </div>

                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="sponsorLogo">Sponsor Logo</Label>
                                  <Dropzone
                                    getUploadParams={getUploadParams}
                                    onChangeStatus={handleSponsorLogoUploadStatus}
                                    styles={{
                                      dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                      inputLabelWithFiles: { margin: '20px 3%' }
                                    }}
                                    canRemove={false}
                                    PreviewComponent={Preview}
                                    accept="image/*"
                                  />
                                  {sponsorLogo && (
                                    <div className="mt-2">
                                      <img
                                        className="avatar-xl"
                                        src={'https://megasubdomain.stechomeyazilim.info/' + sponsorLogo}
                                        alt="Yüklenen Sponsor Logo"
                                      />
                                    </div>
                                  )}
                                  {validation.touched.Sponsor_Logo &&
                                    validation.errors.Sponsor_Logo ? (
                                    <FormFeedback type="invalid" className="d-block">
                                      {validation.errors.Sponsor_Logo}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </>
                            )}

                            <h5 className="font-size-14 mb-3 mt-4">Hedef Kitle (Opsiyonel)</h5>
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollGender">Cinsiyet</Label>
                              <Input
                                id="pollGender"
                                name="Poll_Gender"
                                type="select"
                                className="form-select"
                                onChange={(e) => _setChoiceGender(e)}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_Gender || ""}
                              >
                                <option value="">Tümü</option>
                                <option value="M">Erkek</option>
                                <option value="F">Kadın</option>
                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollAge">Yaş Aralığı (Örn: 18-24)</Label>
                              <Input
                                id="pollAge"
                                name="Poll_Age"
                                type="text"
                                placeholder="Yaş Aralığı Giriniz (örn: 18-24)"
                                onChange={(e) => _setChoiceAge(e)}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_Age || ""}
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollCity">Şehir Seçiniz</Label>
                              <Input
                                id="pollCity"
                                name="Poll_City"
                                type="select"
                                className="form-select"
                                onChange={(e) => _setChoiceCity(e)}
                                onBlur={validation.handleBlur}
                                value={validation.values.Poll_City || ""}
                              >
                                <option value="">Lütfen Şehir Seçiniz (Opsiyonel)</option>
                                {getCities.map((city) => (
                                  <option value={city.name} key={city.id}>{city.name}</option>
                                ))}
                              </Input>
                            </div>

                            <h5 className="font-size-14 mb-3 mt-4">Durum</h5>
                            <div className="mb-3">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pollStatusOptions"
                                  id="statusDraft"
                                  value="Taslak"
                                  defaultChecked={pollStatus === "Taslak"} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setPollStatus(e.target.value);
                                    validation.setFieldValue("Poll_Status", e.target.value);
                                    setPublishDateTime(null); // Taslak veya Yayında ise yayınlama tarihi temizlenir
                                    validation.setFieldValue("Publish_DateTime", null);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="statusDraft">
                                  Taslak
                                </Label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pollStatusOptions"
                                  id="statusPublished"
                                  value="Yayında"
                                  defaultChecked={pollStatus === "Yayında"} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setPollStatus(e.target.value);
                                    validation.setFieldValue("Poll_Status", e.target.value);
                                    setPublishDateTime(null); // Taslak veya Yayında ise yayınlama tarihi temizlenir
                                    validation.setFieldValue("Publish_DateTime", null);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="statusPublished">
                                  Yayında
                                </Label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="pollStatusOptions"
                                  id="statusScheduled"
                                  value="Planlandı"
                                  defaultChecked={pollStatus === "Planlandı"} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setPollStatus(e.target.value);
                                    validation.setFieldValue("Poll_Status", e.target.value);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="statusScheduled">
                                  Yayınlama zamanını planla
                                </Label>
                              </div>
                            </div>

                            {pollStatus === "Planlandı" && (
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="publishDateTime">Yayın Tarihi ve Saati</Label>
                                <Flatpickr
                                  id="publishDateTime"
                                  className="form-control d-block"
                                  placeholder="Tarih ve Saat Seçiniz"
                                  value={publishDateTime} // state tarafından yönetiliyor
                                  onChange={([date]) => {
                                    setPublishDateTime(date);
                                    validation.setFieldValue("Publish_DateTime", date);
                                  }}
                                  options={{
                                    enableTime: true,
                                    dateFormat: "Y-m-d H:i",
                                    minDate: "today",
                                  }}
                                />
                                {validation.touched.Publish_DateTime && validation.errors.Publish_DateTime ? (
                                  <FormFeedback type="invalid" className="d-block">
                                    {validation.errors.Publish_DateTime}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            )}

                         
                           {/** 
                            *    <h5 className="font-size-14 mb-3 mt-4">Ek Özellikler</h5>
                            * <div className="mb-3">
                              <div className="form-check mb-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="isLikesActive"
                                  defaultChecked={isLikesActive} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setIsLikesActive(e.target.checked);
                                    validation.setFieldValue("IsLikesActive", e.target.checked);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="isLikesActive">
                                  Beğeni aktif olsun
                                </Label>
                              </div>
                              <div className="form-check mb-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="isCommentsActive"
                                  defaultChecked={isCommentsActive} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setIsCommentsActive(e.target.checked);
                                    validation.setFieldValue("IsCommentsActive", e.target.checked);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="isCommentsActive">
                                  Yorumlara açık
                                </Label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="isSuggestionsActive"
                                  defaultChecked={isSuggestionsActive} // checked prop'u state tarafından yönetilmeli
                                  onChange={(e) => {
                                    setIsSuggestionsActive(e.target.checked);
                                    validation.setFieldValue("IsSuggestionsActive", e.target.checked);
                                  }}
                                />
                                <Label className="form-check-label" htmlFor="isSuggestionsActive">
                                  Soru önerisine açık (kullanıcılardan benzer soru önerisi alabilir)
                                </Label>
                              </div>
                            </div>*/} 

                            <h5 className="font-size-14 mb-3 mt-4">Seçenekler</h5>
                            <div className="mb-3">
                              {/* PollOptionsManager'ın entegrasyonu */}
                              {isEdit ? (
                                // Düzenleme modu: Mevcut anketin ID'si ve seçenekleriyle çalış
                                <PollOptionsManager
                                  pollId={currentPoll ? currentPoll.ID : null} // currentPoll undefined olabilir
                                  initialOptions={currentPoll ? currentPoll.Poll_Options || [] : []}
                                  onOptionActionSuccess={refreshPolls}
                                  isNewPoll={false} // Bu modda API çağrısı yapmalı
                                />
                              ) : (
                                // Yeni anket ekleme modu: pollId gönderme, isNewPoll true yap
                                <PollOptionsManager
                                  pollId={null} // Yeni anket için henüz ID yok
                                  initialOptions={newPollOptions} // Yeni eklenen seçenekleri PollOptionsManager'a gönder
                                  onOptionsChange={handleNewPollOptionsChange} // PollOptionsManager'daki değişiklikleri yakala
                                  isNewPoll={true} // Bu modda yerel olarak çalışmalı
                                />
                              )}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label" htmlFor="pollImage">Anket Görseli</Label>
                              <Dropzone
                                getUploadParams={getUploadParams}
                                onChangeStatus={handleChangeStatus}
                                styles={{
                                  dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                  inputLabelWithFiles: { margin: '20px 3%' }
                                }}
                                canRemove={false}
                                PreviewComponent={Preview}
                                accept="image/*"
                              />
                              {getFileName && (
                                <div className="mt-2">
                                  <img
                                    className="avatar-xl"
                                    src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
                                    alt="Yüklenen Görsel"
                                  />
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                {!!isEdit ? "Güncelle" : "Kaydet"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);